import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import {Picker} from "emoji-mart";
import {
    Classes, Intent, Spinner, Position, Tooltip, Callout, MenuItem, Button, Tag, Popover, PopoverInteractionKind
} from "@blueprintjs/core";
import SmsCounter from "sms-counter";

import ContentEditableTextarea from "../common/ContentEditableTextarea";
import AddPaymentMethodModal from '../modals/AddPaymentMethodModal';
import SendTestMessageModal from "../modals/SendTestMessageModal";
import CostEstimateModal from "../modals/CostEstimateModal";
import PaymentMethodMissingModal from "../modals/PaymentMethodMissingModal";
import PaymentMethodExpiredModal from "../modals/PaymentMethodExpiredModal";
import SMSSentModal from "../modals/SMSSentModal";
import countries from "../common/countries";
import ReactGA from "react-ga";
import {default as authService, getCurrentUserId, getJwt} from '../../services/authService';
import {MultiSelect, Select} from "@blueprintjs/select";
import http from "../../services/httpService";
import toastr from "toastr";
import StripeReplacementModal from '../modals/StripeReplacementModal';
import UpsellModal from "../modals/UpsellModal";
import {Call} from "@material-ui/icons";
import {POSITION_BOTTOM} from "@blueprintjs/core/lib/esnext/common/classes";
import EmojiTextArea from "../common/EmojiTextArea";
import UpsellModalTailwind from "../modals/UpsellModalTailwind";
import CampaignsTextArea from "../common/CampaignsTextArea";

class Sms extends Component {
    state = {
        characterCount: 0,
        messageContent: '',
        messageHTML: '',
        personalizationNotice: false,
        messagesNumber: 0,
        charsRemaining: 160,
        sendTestMessageModalActive: false,
        rows: 5,
        minRows: 5,
        costEstimate: '',
        costEstimateModalActive: false,
        upgradeModalActive: false,
        listOfNumbers: '',
        numbersArray: [],
        firstMount: true,
        senders: [{text: 'Alphanumeric Sender ID', value: 'Alphanumeric Sender ID'}, {
            text: 'Disabled', value: 'Disabled'
        }],
        selectedSender: 'Alphanumeric Sender ID',
        selectedRecipient: 'All Contacts',
        selectedWhen: 'Immediately',
        selectedTags: [],
        combineOperators: [{
            text: 'AND (Contact must match each criteria specified)', value: 'AND'
        }, {text: 'OR (Contact must match one of the criteria specified)', value: 'OR'}],
        selectedOperator: 'AND (Contact must match each criteria specified )',
        selectedCountries: [],
        selectedDialCodes: [],
        dropdownWidth: '',
        contactsCount: '',
        brand: '',
        selectedTagIds: [],
        highlightCostEstimate: '',
        loading: false,
        disabled: false,
        noContacts: false,
        balance: 0,
        contactsError: false,
        personalizeOptions: [],
        freeMessages: '',
        remainingCredits: '',
        freeMessagesUsed: '',
        attemptingMessages: '',
        selectedSource: this.props.selectedSource,
        selectedSourceFull: '',
        sourcePlan: this.props.selectedSourceNode && this.props.selectedSourceNode.plan && this.props.selectedSourceNode.plan.plan_id ? this.props.selectedSourceNode.plan.plan_id : '',
        update: true,
        modalButtonLabel: '',
        modalButtonLink: '',
        projectPayment: '', //errors
        //balanceError: false,
        brandError: false,
        showContactsCount: false,
        personalizationError: false,
        estimateError: false,
        emptyMessageError: false,
        additionalChargeDisclaimer: false, //modal settings
        upgradeModalTitle: '',
        upgradeModalContent: '',
        user: this.props.user,
        improperPhones: [],
        paymentMethods: [],
        paymentMethodModal: false,
        paymentMethodExpiredModal: false,
        currentDate: '',
        personalizeParameters: [],
        personalize: 0,
        smsSentModalActive: false,
        currentPlanLimitations: '',
        plansData: this.props.plansData,
        currentPlanData: '',
        currentPlatformLimitations: '',
        country: '',
        listOfEuAbbreviations: ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'GR', 'HR', 'IT', 'CY', 'LV', 'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK', 'GB'],
        projectPhones: [],
        alphanumericId: '',
        sender: '',
        workspaceBalance: '',
        workspaceCredits: '',
        topUpAmount: '',
        topUpDollars: '',
        newBalance: '',
        vatPercent: '',
        topUpBalance: false,
        cursorPosition: 0,
        phonesSource: '',
        smsWontBeSent: false,
        checkErrors: false,
        addPaymentMethodModalActive: false,
        stripeReplacementModal: false,
        verifiedNumbers: [],
        verifiedNumbersIds: [],
        isOpen: false,
        rerunCampaignData: '', //selectedSource: this.props.selectedSource

    };

    componentDidMount = () => {
        //await this.getCostEstimate()
        //
        // //console.log('componentDIdMount user: ', this.state.user)
        // //console.log('componentDIdMount user sources: ', this.state.user.sources.data)
        // //console.log('componentDIdMount selected source id: ', this.state.selectedSource)
        let selectedSource = this.state.selectedSource

        let selectedSourceFull = this.state.user.sources.data.filter(source => {
            // //console.log('current source Id : ', source.id)
            // //console.log('selectedSource id :', this.state.selectedSource);
            return source.id.toString() === this.state.selectedSource.toString()

        })
        //console.log('cdm - selected source full: ', selectedSourceFull)
        // console.log('this.props.location: ', this.props.location)
        const postDataPassed = this.props.location.state ? this.props.location.state.post : '';
        if (postDataPassed && postDataPassed.short_url) {
            this.setState({messageContent: postDataPassed.short_url, messageHTML: postDataPassed.short_url})
        }

        let alphanumericId = ''
        if (selectedSourceFull[0]) {
            alphanumericId = selectedSourceFull[0].alphanumeric_id
        }

        let today = new Date();
        let dateFormat = [today.getFullYear(), today.getMonth() + 1, //  today.getDate()
        ].join('-')

        this.setState({
            currentDate: dateFormat
        })

        this.getUserBilling()

        let workspaceBalance = ''
        let workspaceCredits = ''
        if (selectedSourceFull[0]) {
            if (selectedSourceFull[0].project_balance) {
                workspaceBalance = Number(selectedSourceFull[0].project_balance.balance_cents / 100).toFixed(2)
                workspaceCredits = Number(selectedSourceFull[0].project_balance.credits).toFixed(2)

            }
        }
        // if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
        this.getVerifiedNumbers()
        // }

        this.setState({
            selectedSource,
            selectedSourceFull,
            alphanumericId,
            sender: alphanumericId,
            workspaceBalance,
            workspaceCredits
        })

        //rerun handle
        let selectedTags = []
        let selectedTagIds = []
        let allTags = this.props.tags
        if (this.props.location.state) {
            if (this.props.location.state.id) {

                //console.info('this.props.location.state: ', this.props.location.state)

                let existingTag = ''
                if (this.props.location.state.tags[0] !== 'Everyone') {

                    let rerunTags = this.props.location.state.tags
                    //console.info('rerunTags: ', rerunTags)


                    if (rerunTags) {
                        rerunTags.forEach((el, i) => {
                            //console.info('entered loop')

                            existingTag = allTags.filter(tag => {
                                return tag.tag === el
                            })
                            //console.info('existingTag: ', existingTag)
                            // let filteredTag = existingTag.filter(function (el) {
                            //     return el != null;
                            // });
                            // console.log('filteredTag: ', filteredTag)
                            if (existingTag.length !== 0) {
                                selectedTags.push(existingTag[0])
                                selectedTagIds.push(existingTag[0].id)
                            }

                        })
                    } else {
                        selectedTags = []
                        selectedTagIds = []
                    }
                    this.setState({

                        selectedRecipient: 'Use Segments',

                    })
                }
                //console.info('this.props.location.state.message_html: ', this.props.location.state.message_html)
                this.setState({
                    selectedTags, selectedTagIds, rerunCampaignData: this.props.location.state
                })

                this.handleMessageUpdate(this.props.location.state.message)
            }
        }


        this.calculateFreeSMS(selectedSourceFull)
        this.getProjectPhones()
        this.getCostEstimate()

    };

    cleanHTMLMessage = (html) => {
        let cleanMessage = String(html)
        //console.log('Content editable html: ', html)

        //handling Tags cleaning
        if (cleanMessage.includes('&nbsp;')) {
            cleanMessage = cleanMessage.replace(/&nbsp;/g, ' ')
        }
        if (cleanMessage.includes('&lt')) {
            cleanMessage = cleanMessage.replace(/&lt;/g, ' ')
        }
        if (cleanMessage.includes('&gt')) {
            cleanMessage = cleanMessage.replace(/&gt;/g, ' ')
        }
        if (cleanMessage.includes('<br>')) {
            cleanMessage = cleanMessage.replace(/<br>/g, '\n')
        }
        if (cleanMessage.includes('<div class="delete-personalization-tag" contenteditable="false">×</div>')) {
            cleanMessage = cleanMessage.replace(/<div class="delete-personalization-tag" contenteditable="false">×<\/div>/g, '')
        }
        if (cleanMessage.includes('</span>')) {
            cleanMessage = cleanMessage.replace(/<\/span>/g, '')
        }
        if (cleanMessage.includes('</label>')) {
            cleanMessage = cleanMessage.replace(/<\/label>/g, '')
        }
        if (cleanMessage.includes('<span class="tag noselect" contenteditable="false">first_name')) {
            //console.log('there is first name tag')
            cleanMessage = cleanMessage.replace(/<span class="tag noselect" contenteditable="false">first_name/g, '{first_name}')
        }
        if (cleanMessage.includes('<span class="tag noselect" contenteditable="false">last_name')) {
            //console.log('there is a last name tag')
            cleanMessage = cleanMessage.replace(/<span class="tag noselect" contenteditable="false">last_name/g, '{last_name}')
        }
        if (cleanMessage.includes('<span class="tag noselect" contenteditable="false">full_name')) {
            cleanMessage = cleanMessage.replace(/<span class="tag noselect" contenteditable="false">full_name:/g, '{full_name}')
        }
        if (cleanMessage.includes('<label class="tag trackable-link" contenteditable="false">')) {
            cleanMessage = cleanMessage.replace(/<label class="tag trackable-link" contenteditable="false">/g, '')
        }
        if (cleanMessage.includes('</div><div>')) {
            cleanMessage = cleanMessage.replace(/<\/div><div>/g, '\n')
        }
        if (cleanMessage.includes('<div>')) {
            cleanMessage = cleanMessage.replace(/<div>/g, '\n')
        }

        if (cleanMessage.includes('</div>')) {
            cleanMessage = cleanMessage.replace(/<\/div>/g, "\n")
        }
        if (cleanMessage.includes('<span style="letter-spacing: 0;">')) {
            cleanMessage = cleanMessage.replace(/<span style="letter-spacing: 0;">/g, "")
        }
        if (cleanMessage.includes('«span style= letter-spacing: Opx;"›')) {
            cleanMessage = cleanMessage.replace(/«span style= letter-spacing: Opx;"›/g, "")
        }
        //cleaning all span tags in the end
        if (cleanMessage.match(/<span[^>]*>/g)) {
            cleanMessage = cleanMessage.replace(/<span[^>]*>/g, '')
        }
//cleaning all font open tags in the end
        if (cleanMessage.includes('</font>')) {
            cleanMessage = cleanMessage.replace(/<\/font>/g, '')
        }
        if (cleanMessage.match(/<font[^>]*>/g)) {
            cleanMessage = cleanMessage.replace(/<font[^>]*>/g, '')
        }

        if (cleanMessage.match(/<.+?>/g)) {
            cleanMessage = cleanMessage.replace(/<.+?>/g, '')
        }
        // if (cleanMessage.match(/<.+?>/g)) {
        //     cleanMessage = cleanMessage.replace(/<.+?>/g, '')
        // }
        //console.log('slice: ', this.state.html.slice(-4))

        // if (cleanMessage.includes('\n\n')) {
        //     cleanMessage = cleanMessage.replaceAll('\n\n', "\n")
        // }
        //cleanMessage = cleanMessage.replaceAll(/<[^>]*>?/gm, '')

        //console.log('ContentEditable clean message: ', cleanMessage)
        this.handleSMSCounter(cleanMessage)
        return cleanMessage

    }
    handleSMSCounter = (message) => {
        this.setState({
            characterCount: SmsCounter.count(message).length,
            messagesCount: SmsCounter.count(message).messages,
            charsRemaining: SmsCounter.count(message).remaining,
            charsPerMessage: SmsCounter.count(message).per_message,
        })
    }
    calculateFreeSMS = async (selectedSourceFull) => {
        //console.info('selectedSourceFull: ', selectedSourceFull)

        if (selectedSourceFull.length) {
            let smsPlatformFull = selectedSourceFull[0].platforms.find(platform => {
                return platform.platform === 'sms'
            })
            let freeMessages = smsPlatformFull.free_messages_remaining
            await this.setState({
                freeMessages
            })
        }
    }
    getVerifiedNumbers = async () => {
        let verifiedNumbers
        let verifyNumbersResponse
        if (this.props.selectedSource) {
            try {
                verifyNumbersResponse = await http.get('/api/user/' + getCurrentUserId() + '/project/' + this.props.selectedSource + '/verified_phones/page_size/8?page=1', {headers: {authorization: getJwt()}});
                //console.log('verifyNumbersResponse: ', verifyNumbersResponse)

                //console.log('verifiedNumbers: ', verifyNumbersResponse)

            } catch {
                toastr.error('Verify numbers error')
            }

            if (verifyNumbersResponse) {
                verifiedNumbers = await verifyNumbersResponse.data.verified_phones
                await this.setState({
                    verifiedNumbers
                })
            }

        }
    }


    updateCursorPosition = (places) => {
        this.setState({
            cursorPosition: this.state.cursorPosition + places
        })
    }

    handleSmsFallbackMessage = (message) => {
        this.setState({
            update: true, messageContent: message
        })
        this.getCursorPosition()
    }

    componentDidUpdate = () => {
        if (this.state.selectedSource !== this.props.selectedSource) {
            //console.log('componentDidUpdate  - id different 1')
            //console.log('cdu1  - selectedSourceProps: ', this.props.selectedSource)
            //console.log('cdu1  - selectedSourceState: ', this.state.selectedSource)

            this.setState({
                selectedSource: this.props.selectedSource
            })

            if (this.props.selectedSource && this.state.selectedSource && this.state.phonesSource !== this.props.selectedSource) {
                //console.log('get numbers selectedSource: ', this.state.selectedSource)
                this.getProjectPhones();
                this.setState({
                    phonesSource: this.props.selectedSource
                })
            }
            let selectedSource = this.props.selectedSource;

            let selectedSourceFull = []


            let selectedSourceData = this.props.user && this.props.user.sources && this.props.user.sources.data.length ? this.props.user.sources.data.find(source => source.id.toString() === selectedSource.toString()) : '';
            selectedSourceFull[0] = selectedSourceData
            //let selectedFeedSharedData = this.props.user && this.props.user.feeds_shared && this.props.user.feeds_shared.length ? this.props.user.feeds_shared.find(feed => feed.project_id.toString() === selectedSource.toString()) : ''

            // let alphanumericId = selectedSourceData.alphanumeric_id ? selectedSourceData.alphanumeric_id :
            //     selectedFeedSharedData && selectedFeedSharedData.alphanumeric_id ? selectedFeedSharedData.alphanumeric_id : '';

            let alphanumericId = selectedSourceData.alphanumeric_id

            if (alphanumericId !== this.state.alphanumericId) {
                this.setState({
                    alphanumericId, sender: alphanumericId
                })
            }

            //console.log('alphanumeric ID : ', alphanumericId)
            let smsPlatform = selectedSourceFull && selectedSourceFull.length ? selectedSourceFull[0].platforms.filter(platform => platform.platform === 'sms') : '';
            ////console.log('sms platform :', smsPlatform);

            // await this.setState({
            //     selectedSourceFull: selectedSourceFull,
            //     sourcePlan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',
            //     freeMessages: smsPlatform[0] ? smsPlatform[0].free_messages_remaining : this.state.freeMessages,
            //     country: selectedSourceFull && selectedSourceFull.length && selectedSourceFull[0].default_billing_details ? selectedSourceFull[0].default_billing_details.address.country : ''
            // })

            ////console.log('plansData: ', this.props.plansData)
            let plansData = [...this.props.plansData]
            let currentPlanData = plansData.filter(plan => {
                return plan.plan_id === this.state.sourcePlan
            })
            ////console.log('current plan data: ', currentPlanData);
            this.setState({currentPlanData})

            //console.log('selectedSourceFull CDU: ', selectedSourceFull)
            let smsPlatformFull = selectedSourceFull[0].platforms.find(platform => {
                return platform.platform === 'sms'
            })
            let freeMessagesRemaining = smsPlatformFull.free_messages_remaining
            let workspaceBalance = ''
            let workspaceCredits = ''
            if (selectedSourceFull[0].project_balance) {
                workspaceBalance = Number(selectedSourceFull[0].project_balance.balance_cents / 100).toFixed(2)
                workspaceCredits = Number(selectedSourceFull[0].project_balance.credits).toFixed(2)
            }
            this.getVerifiedNumbers()

            this.setState({
                selectedSourceFull,
                workspaceBalance,
                workspaceCredits,
                sourcePlan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',
                selectedTags: [],
                selectedTagIds: [],
                freeMessages: freeMessagesRemaining,
            })

            this.getUserBilling()
            this.getCostEstimate()

        }


        if (this.state.currentPlanLimitations !== this.props.currentPlanLimitations) {
            this.setState({
                currentPlanLimitations: this.props.currentPlanLimitations,
                currentPlatformLimitations: this.props.currentPlatformLimitations
            })

            // //console.log('sms component did update - current plan limitations: ', this.props.currentPlanLimitations)
        }


    }

    getUserBilling = async () => {
        // console.log('this.props.selectedSource: ', this.props.selectedSource)
        ////console.log('currentUserId: ', getCurrentUserId())
        ////console.log('user: ', this.props.user)

        if (this.props.selectedSource !== '') {
            try {
                ////console.log('billing call: ', '/api/user/' + getCurrentUserId() + '/project/' + this.props.selectedSource + '/customers/get_payment_methods_project')
                const billingResult = await http.get('/api/user/' + getCurrentUserId() + '/project/' + this.props.selectedSource + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                // //console.log('billing call result: ', billingResult)
                let defaultPayment = billingResult.data.project_payment_methods.find(payment => payment.project_default === 1);
                // console.log('billingResult: ', billingResult)
                this.setState({
                    projectPayment: billingResult.data.project_payment_methods[0] ? defaultPayment : '',
                })
            } catch (e) {
                toastr.error('Something went wrong... Please try again.')
            }
        }
    }

    upgradeToPro = async () => {
        if (this.state.projectPayment !== '') {
            if (this.state.freeMessages !== '' && this.state.freeMessages === 0) {
                this.setState({
                    upgradeModalActive: true,

                    upgradeModalTitle: <span><i
                        className='fas fa-`g'></i>You’ve reached your 10 Free SMS limit.</span>,
                    upgradeModalContent: <p className='text-center'>
                        You have now spent all of your free credits. Future SMS campaigns will be charged on
                        Pay-as-you-go basis.<br></br>
                        Notice that if your messages cost is under $0.6 you will be charged $0.6 due to Stripe Policy.
                        In order to continue with your campaign you need to add payment method, otherwise you won’t be
                        able to send.
                    </p>,
                    modalButtonLabel: 'Confirm',
                    modalButtonLink: ''

                })
            }
        } else {
            if (this.state.sourcePlan !== '' && this.state.sourcePlan === 'free_plan' && this.state.freeMessages !== '' && this.state.freeMessages === 0) {
                this.setState({
                    upgradeModalActive: true,

                    upgradeModalTitle: <span><i
                        className='fas fa-flag'></i>You’ve reached your 10 Free SMS limit.</span>,
                    upgradeModalContent: <p className='text-center'>
                        From now on, you will be charged certain amount per message. Notice that if your messages
                        cost
                        is under $0.6 you <br></br>
                        will be charged $0.6 due to Stripe Policy.<br></br>
                        In order to continue with your campaign you need to add payment method, otherwise you won’t
                        be
                        able
                        to send.</p>,
                    modalButtonLabel: 'Add New Payment Method',
                    modalButtonLink: '/billing/payment-methods'

                })
            }
        }
    }


    openUpgradeModal = () => {
        this.setState({
            upgradeModalActive: true,
            upgradeModalTitle: 'Segmentation is not available on your current plan.',
            upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`

        })
    }

    handleBrand = (brand) => {
        ////console.log('brand: ', brand)
        let letterNumber = /^[0-9a-zA-Z ]+$/;
        if (brand.match(letterNumber) || brand === '') {
            this.setState({
                brand, brandError: false
            })
        } else {
            this.setState({
                brandError: true
            });
        }

    }
    updateCostEstimate = async () => {
        this.setState({
            contactsError: false
        })
        if (this.state.messageContent) {
            this.getCostEstimate()
        } else {
            await this.setState({
                emptyMessageError: true, checkErrors: true
            })

        }
        await this.setState({
            firstMount: false
        })
    }


    handleMessageUpdate = (message) => {
        // console.log('handleMessageUpdate started')
        //console.log('message: ', message)
        let personalizationNotice = false
        let personalizeParameters = []

        if (message.includes('{first_name}')) {
            personalizationNotice = true
            if (!personalizeParameters.includes("first_name")) {
                personalizeParameters = [...personalizeParameters, "first_name"]
            }
        }
        if (message.includes('{last_name}')) {
            personalizationNotice = true

            if (!personalizeParameters.includes("last_name")) {
                personalizeParameters = [...personalizeParameters, "last_name"]
            }
        }
        if (message.includes('{full_name}')) {
            personalizationNotice = true

            if (!personalizeParameters.includes("full_name")) {
                personalizeParameters = [...personalizeParameters, "full_name"]
            }
        }

        this.setState({
            messageContent: message,
            update: true,
            personalizeParameters,
            personalize: personalizeParameters.length > 0 ? 1 : 0,
            personalizationNotice
        })
    }

    handleListOfNumbers = (numbers) => {
        this.setState({listOfNumbers: numbers})
        this.countPhoneNumbers();
    }

    countPhoneNumbers = () => {
        let count = this.state.listOfNumbers.split(',').length
        this.setState({contactsCount: count})
    }

    getCostEstimate = async () => {
        //console.log('get cost estimate started')

        await this.setState({
            highlightCostEstimate: false, topUpBalance: false
        })
        let selectedSourceFull = this.state.selectedSourceFull
        // console.log('selectedSourceFull: ', selectedSourceFull)
        let smsPlatform = []
        ////console.log('selectedSource full: ', selectedSourceFull)
        if (selectedSourceFull) {
            if (selectedSourceFull[0]) {
                smsPlatform = selectedSourceFull[0].platforms.filter(platform => platform.platform === 'sms')
                //console.log('sms platform :', smsPlatform);

            }

            //DONT SET STATE FREE MESSAGES IN COST ESTIMATE
            await this.setState({
                smsWontBeSent: false,
                selectedSourceFull: selectedSourceFull,
                country: selectedSourceFull[0] ? selectedSourceFull[0].default_billing_details ? selectedSourceFull[0].default_billing_details.address.country : '' : '',
                disabled: true,
                emptyMessageError: false,
                contactsError: false, //balanceError: false,
                estimateError: false,
                additionalChargeDisclaimer: false,
                improperPhones: [],
                sourcePlan: this.props.selectedSourceNode && this.props.selectedSourceNode.plan && this.props.selectedSourceNode.plan.plan_id ? this.props.selectedSourceNode.plan.plan_id : '',
                noContacts: false,
                checkErrors: false
            });

            let userId = getCurrentUserId();
            ////console.log('free messages start: ', freeMessagesStart);

            //checking if user has contacts
            if (this.state.selectedSourceFull !== '' && selectedSourceFull[0] && smsPlatform !== [] && smsPlatform[0]) {
                try {
                    await this.setState({
                        loading: true
                    });
                    let selectedSource = this.props.selectedSource;

                    // //console.log('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/imported_contacts/page_size/' + '10' + '?page=' + '1')
                    //const contactsResult = await http.get('/api/user/' + userId + '/project/' + selectedSource + '/imported_contacts/page_size/' + '10' + '?page=' + '1', {headers: {authorization: getJwt()}})
                    // //console.log('contactsResult: ', contactsResult);

                    // await this.setState({
                    //     contactsCount: contactsResult.data.total_count
                    // });

                    // if user has contacts -> getting cost estimate

                    // if (contactsResult.data.total_count !== 0 || this.state.numbersArray !== 0) {


                    let selectedTagIds = [];
                    const selectedTags = this.state.selectedTags;


                    this.state.selectedTags.map(tag => {
                        selectedTagIds = [...selectedTagIds, tag.id]
                    });
                    this.setState({
                        selectedTagIds: selectedTagIds
                    })
                    let data = {};
                    // //console.log('selectedRecepient: ', this.state.selectedRecipient)
                    this.handleMessageUpdate(this.state.messageContent)

                    if (this.state.selectedRecipient === 'Add Manually') {
                        // //console.log('entered add manually data')
                        data = {
                            "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                            "from": this.state.sender, //"provider": "twilio",//to calculate-obtain price for estimate based on provider prices
                            "model_type": "all",//fixed to “all” currently
                            "model_gender": "all",//fixed to “all” currently
                            "tag_segmentation": 0,//use tags or not for sending
                            "tag_ids": [],//list of tag ids (existing tags client previously created)
                            "manual_contacts": 1,//use manually pasted contacts (phone numbers)
                            "phones": this.state.numbersArray,//send as an array of phones
                            "phones2": [],//send as string with comma separated values
                            "country_codes": [],//which country codes to include in sending-sends only to contacts who match this criteria
                            "personalize_parameters": [], "personalize": 0, "message_html": this.state.messageHTML

                        }
                    } else if (this.state.selectedRecipient === 'All Contacts') {
                        // //console.log('entered all contacts data')
                        data = {
                            "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                            "from": this.state.sender, //"provider": "twilio",//to calculate-obtain price for estimate based on provider prices
                            "model_type": "all",//fixed to “all” currently
                            "model_gender": "all",//fixed to “all” currently
                            "tag_segmentation": 0,//use tags or not for sending
                            "tag_ids": [],//list of tag ids (existing tags client previously created)
                            "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                            "phones": [],//send as an array of phones
                            "phones2": [],//send as string with comma separated values
                            "country_codes": [],//which country codes to include in sending-sends only to contacts who match this criteria,
                            "personalize_parameters": this.state.personalizeParameters,
                            "personalize": this.state.personalize,
                            "message_html": this.state.messageHTML
                        }
                    } else {
                        // //console.log('entered use segments data')
                        data = {
                            "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                            "from": this.state.sender, //"provider": "twilio",//to calculate-obtain price for estimate based on provider prices
                            "model_type": "all",//fixed to “all” currently
                            "model_gender": "all",//fixed to “all” currently
                            "tag_segmentation": this.state.selectedTags.length > 0 ? 1 : 0,//use tags or not for sending
                            "tag_ids": selectedTagIds,//list of tag ids (existing tags client previously created)
                            "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                            "phones": [],//send as an array of phones
                            "phones2": [],//send as string with comma separated values
                            "country_codes": this.state.selectedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                            "personalize_parameters": this.state.personalizeParameters,
                            "personalize": this.state.personalize,
                            "message_html": this.state.messageHTML


                        }
                    }

                    //console.log('cost estimate data: ', data);
                    try {
                        // //console.log('enteredSendingCostEstimate call')
                        ////console.log('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/cost_estimate');
                        ////console.log('cost estimate data: ', data);

                        let result = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/cost_estimate', data, {
                            headers: {
                                authorization: authService.getJwt()
                            }
                        });

                        //console.info('getCostEstimate result: ', result)
                        // //console.log('free messages start (before calc):', freeMessagesStart);
                        let freeMessagesStart = result.data.initial_sms_remaining

                        //console.log('freeMessagesStart: ', freeMessagesStart)
                        //console.log('result.data.free_messages_remaining: ', result.data.free_messages_remaining)
                        let freeMessagesUsed = freeMessagesStart !== '' ? freeMessagesStart - result.data.free_messages_remaining : 0;
                        //console.log('free messages used: ', freeMessagesUsed)

                        let improperPhones = result.data.improper_phones ? result.data.improper_phones[0] === null ? [] : result.data.improper_phones : []

                        this.setState({
                            improperPhones
                        })

                        let freeMessagesRemaining = result.data.error ? '/' : result.data.initial_sms_remaining
                        let costEstimate = result.data.error ? result.data.error : Number(result.data.estimate < 0.01 ? result.data.estimate.toFixed(4) : result.data.estimate.toFixed(2))
                        let additionalChargeDisclaimer = false
                        // //console.log('freeMessagesRemaining: ', freeMessagesRemaining)
                        // //console.log('costEstimate: ', costEstimate)
                        if (freeMessagesRemaining > 0 && Number(costEstimate) > 0) {
                            additionalChargeDisclaimer = true
                        }

                        //console.log('workspace_credits_remaining: ', result.data.workspace_credits_remaining)
                        //console.log('result.data: ', result.data)
                        let topUpAmount = result.data.top_up_amount//(-result.data.workspace_credits_remaining).toFixed(2) < 0.01 ? 0 : (-result.data.workspace_credits_remaining).toFixed(2)
                        let topUpDollars = result.data.top_up_amount_balance
                        //console.log('topUpAmount: ', topUpAmount)

                        let workspaceBalance = this.state.workspaceBalance
                        // console.log('workspaceBalance: ', workspaceBalance)

                        if (!workspaceBalance) {
                            //console.log('no balance')
                            if (Number(topUpAmount) !== 0) {
                                //  console.log('top up is not 0')
                                if (topUpAmount <= 1000) {
                                    //console.log(workspaceBalance:  'topUpAmount is lower than 15: ', topUpAmount)
                                    //console.log('result.data.estimate: ', result.data.estimate)
                                    //topUpAmount = 1000
                                    await this.setState({
                                        topUpAmount: topUpAmount.toFixed(2),
                                        topUpDisclaimer: true,
                                        topUpDollars: Number(topUpDollars).toFixed(2),
                                        remainingCredits: Number(result.data.workspace_credits_remaining).toFixed(2)
                                    })
                                } else {
                                    // console.log('topUpAmount is bigger than 15: ', topUpAmount)
                                    // console.log('result.data.estimate: ', result.data.estimate)

                                    await this.setState({
                                        topUpAmount: Number(topUpAmount).toFixed(2),
                                        topUpDollars: Number(topUpDollars).toFixed(2),
                                        topUpDisclaimer: false,
                                        remainingCredits: Number(result.data.workspace_credits_remaining).toFixed(2)
                                    })
                                }
                            } else {
                                // console.log('top up amount is 0')
                                await this.setState({
                                    topUpAmount: 0,
                                    topUpDollars: Number(topUpDollars).toFixed(2),
                                    topUpDisclaimer: false,
                                    remainingCredits: Number(result.data.workspace_credits_remaining).toFixed(2)
                                })
                            }
                        } else {
                            // console.log('has balance')
                            // console.log('topUpAmount: ', topUpAmount)
                            if (Number(topUpAmount) !== 0) {
                                // console.log('top up is not 0')
                                if (Number(topUpAmount) <= 1000) {
                                    // console.log('topUpAmount is lower than 15: ', topUpAmount)
                                    // console.log('result.data.estimate: ', result.data.estimate)

                                    topUpAmount = 1000
                                    await this.setState({
                                        topUpAmount: Number(topUpAmount).toFixed(2),
                                        topUpDollars: Number(topUpDollars).toFixed(2),

                                        topUpDisclaimer: true,
                                        remainingCredits: Number(result.data.workspace_credits_remaining).toFixed(2)
                                    })
                                } else {
                                    // console.log('topUpAmount is bigger than 15: ', topUpAmount)
                                    // console.log('result.data.estimate: ', result.data.estimate)

                                    await this.setState({
                                        topUpAmount: Number(topUpAmount).toFixed(2),
                                        topUpDollars: Number(topUpDollars).toFixed(2),

                                        topUpDisclaimer: false,
                                        remainingCredits: Number(result.data.workspace_credits_remaining).toFixed(2)
                                    })
                                }
                            } else {
                                // console.log('top up amount 0')
                                await this.setState({
                                    topUpAmount: 0,
                                    topUpDollars: Number(topUpDollars).toFixed(2),

                                    topUpDisclaimer: false,
                                    remainingCredits: Number(result.data.workspace_credits_remaining).toFixed(2)
                                })
                            }
                        }

                        if (result.data.count === 0) {
                            //console.log('result.data.count is 0')

                            await this.setState({
                                noContacts: true,
                                loading: false,
                                disabled: false,
                                costEstimate: '0',
                                freeMessages: freeMessagesRemaining,
                                freeMessagesUsed,
                                vatPercent: 0,


                            })
                            if (!this.state.firstMount) {
                                this.setState({
                                    contactsError: true, firstMount: false,
                                })
                                //toastr.error('Please check errors.')
                            }
                        } else {
                            // console.log('result.data.count is NOT 0')
                            await this.setState({
                                noContacts: false,
                                contactsCount: result.data.count,
                                showContactsCount: true, //freeMessages: result.data.error ? result.data.error : result.data.free_messages_remaining,
                                loading: false,
                                disabled: this.state.currentPlanLimitations ? this.state.currentPlanLimitations.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments' : true,
                                estimateError: !!result.data.error,
                                costEstimate: result.data.error ? result.data.error : result.data.estimate < 0.1 ? result.data.estimate.toFixed(4) : result.data.estimate.toFixed(2),
                                attemptingMessages: result.data.error ? result.data.total_subscribers : '', //remainingCredits: result.data.error ? result.data.remaining_credits : '',
                                freeMessagesUsed, //freeMessages: freeMessagesRemaining,
                                update: false,
                                improperPhones,
                                additionalChargeDisclaimer: additionalChargeDisclaimer,
                                vatPercent: result.data.error ? 0 : result.data.vat_percent,
                                freeMessagesRemaining: result.data.error ? result.data.error : result.data.free_messages_remaining,
                                freeMessagesInitial: result.data.error ? result.data.error : result.data.initial_sms_remaining
                            })

                            let newBalance = ''
                            if (result.data.credit_remaining) {
                                newBalance = Number(result.data.credit_remaining)
                            }
                            await this.setState({
                                newBalance, firstMount: false
                            })

                        }
                    } catch (e) {
                        // //console.log('getCostEstimate error: ', e)
                        toastr.error('Cost estimation went wrong... Please refresh and try again.');

                        this.setState({
                            loading: false, disabled: false, noContacts: false, smsWontBeSent: true, firstMount: false
                        })
                    }
                    //}


                } catch (e) {
                    ////console.log('getContactsError: ', e)
                    toastr.error('Something went wrong... Please try again.');
                    this.setState({loading: false})
                }
            }
        }
    }

    getParameters = (str) => {
        let results = [], re = /{{([^}]+)}}/g, text;

        while (text = re.exec(str)) {
            results.push(text[1]);
        }
        return results;
    };
    sendTestSMS = async (verifiedNumbers, verifiedIds) => {
        // console.log('sendTestMessage run')
        // console.log('verified numbers: ', verifiedNumbers)
        await this.setState({
            selectedRecipient: 'Add Manually',
            sendTestMessageModalActive: false,
            update: false,
            numbersArray: verifiedNumbers,
            verifiedNumbersIds: verifiedIds
        })
        await this.getCostEstimate()
        await this.startCampaign('test')
    }
    //sendSMS


    startLogCampaign = async () => {
        if (this.state.update === false) {

            if (this.state.costEstimate !== '' && Number(this.state.costEstimate) !== 0) {

                this.sendLogSMS()

            } else {
                await this.setState({
                    highlightCostEstimate: true
                })
            }
        } else {
            toastr.error('Please update estimated cost before starting campaign!')
        }
    };


    sendLogSMS = async () => {
        // console.log('enteredSendSMS')
        //await this.getCostEstimate()
        // let insufficientBalance = false;//this.state.balance < this.state.costEstimate;
        let zeroContacts = this.state.contactsCount === 0 || this.state.noContacts;
        let personalizationError = false;
        let personalizeOptions = this.state.personalizeOptions
        let improperPhonesError = this.state.improperPhones
        let emptyMessageError = this.state.emptyMessageError
        emptyMessageError = this.state.messageContent === '';
        let i = 0;
        if (this.state.messageContent.includes("{{")) {

            let result = this.getParameters(this.state.messageContent);
            ////console.log('parameters result :', result);

            for (i; i < result.length; i++) {
                if (result[i] !== 'first_name' && result[i] !== 'last_name' && result[i] !== 'full_name') {
                    personalizationError = true
                } else {
                    if (!personalizeOptions.includes(result[i])) {

                        personalizeOptions = [...personalizeOptions, result[i]];
                        ////console.log('personalize options after: ', personalizeOptions)
                    }
                    personalizationError = false

                }
            }
        }
        ////console.log('personalize error: ', personalizationError);

        //checking for errors
        await this.setState({
            //balanceError: insufficientBalance,
            contactsError: zeroContacts,
            personalizeOptions: personalizeOptions,
            personalizationError: personalizationError,
            emptyMessageError: emptyMessageError
        });

        if (this.state.update === false) {
            let noErrors = ''
            if (this.state.selectedRecipient === 'Add Manually') {
                noErrors = this.state.estimateError === false && this.state.emptyMessageError === false
                    //&& this.state.balanceError === false
                    && this.state.contactsError === false && this.state.personalizationError === false && this.state.contactsCount !== '' && this.state.improperPhones.length === 0

            } else {
                noErrors = this.state.estimateError === false && this.state.emptyMessageError === false
                    //&& this.state.balanceError === false
                    && this.state.contactsError === false && this.state.personalizationError === false && this.state.contactsCount !== ''

            }
            ////console.log('noErrors: ', noErrors);

            if (noErrors) {
                await this.setState({
                    loading: true, disabled: false
                })
                let userId = getCurrentUserId()
                let selectedSource = this.props.selectedSource;
                let data = '';
                let selectedTagIds = this.state.selectedTagIds


                if (this.state.selectedRecipient === 'Add Manually') {
                    ////console.log('entered add manually data')
                    data = {
                        "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                        "from": this.state.sender, //"provider": "twilio",//to calculate-obtain price for estimate based on provider prices
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 1,//use manually pasted contacts (phone numbers)
                        "phones": this.state.numbersArray,//send as an array of phones
                        "phones2": [],//send as string with comma separated values
                        "country_codes": [],//which country codes to include in sending-sends only to contacts who match this criteria
                        "personalize_parameters": [],
                        "personalize": 0,
                        "message_html": this.state.messageHTML,
                        "ignore_stuff": 1


                    }
                } else if (this.state.selectedRecipient === 'All Contacts') {
                    data = {
                        "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                        "from": this.state.sender, //"provider": "twilio",//to calculate-obtain price for estimate based on provider prices
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "phones2": [],//send as string with comma separated values
                        "country_codes": [],//which country codes to include in sending-sends only to contacts who match this criteria,
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize,
                        "message_html": this.state.messageHTML,
                        "ignore_stuff": 1


                    }
                } else {
                    data = {
                        "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                        "from": this.state.sender, //"provider": "twilio",//to calculate-obtain price for estimate based on provider prices
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": this.state.selectedTags.length > 0 ? 1 : 0,//use tags or not for sending
                        "tag_ids": selectedTagIds,//list of tag ids (existing tags client previously created)
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "phones2": [],//send as string with comma separated values
                        "country_codes": this.state.selectedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize,
                        "message_html": this.state.messageHTML,
                        "ignore_stuff": 1


                    }
                }

                try {

                    // //console.log('send sms data: ', data)
                    // //console.log('send sms call: ', '/api/user/' + userId + '/project/' + selectedSource + '/sms_message')
                    this.handleMessageUpdate(this.state.messageContent)
                    let smsResponse = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/sms_message_testing', data, {
                        headers: {
                            'Content-Type': 'application/json', authorization: authService.getJwt()
                        }
                    })

                    // //console.log('smsResponse: ', smsResponse);

                    if (!smsResponse.data.error) {
                        // console.log('no error')
                        // //console.log('No funds error')
                        if (smsResponse.data.message) {
                            // console.log('has message')
                            if (smsResponse.data.message === 'empty message') {
                                this.setState({
                                    loading: false, disabled: false, update: true, topUpBalance: true
                                })
                            } else {
                                this.setState({
                                    loading: false, disabled: false, update: true, emptyMessageError: true
                                })
                            }
                            //toastr.error('Sending unsuccessful.' + ' ' + smsResponse.data.message)
                            this.props.updateUserFromServer()

                        } else {
                            // console.log('no message')
                            let freeMessagesRemaining = smsResponse.data.error ? this.state.freeMessages : smsResponse.data.free_messages_remaining

                            // console.log('data.free_messages_remaining: ', smsResponse.data.free_messages_remaining)
                            // console.log('free messages remaining after sms: ', freeMessagesRemaining)


                            this.setState({
                                loading: false,
                                disabled: false,
                                freeMessages: freeMessagesRemaining,
                                update: true,
                                smsSentModalActive: true

                            })
                            //this.props.updateUserFromServer()

                        }
                    } else {
                        // console.log('has error')
                        ////console.log('There is funds error')
                        //this.props.updateUserFromServer()

                        this.setState({
                            loading: false, disabled: false, update: true
                        })
                        // console.log('smsResponse.data.message: ', smsResponse.data.message)
                        toastr.error('Sending unsuccessful.' + ' ' + smsResponse.data.message)
                    }
                } catch (e) {
                    ////console.log('send message error: ', e)
                    this.setState({
                        loading: false, disabled: false, checkErrors: true
                    })

                }
            } else {
                this.setState({
                    loading: false, disabled: false, checkErrors: true
                })
            }
        } else {
            toastr.error('Please update estimated cost before starting campaign!')
        }
    }


    startCampaign = async (test) => {
        if (this.state.update === false) {

            if (this.state.costEstimate !== '' && Number(this.state.costEstimate) !== 0) {

                this.sendSMS(test)

            } else {
                await this.setState({
                    highlightCostEstimate: true
                })
            }
        } else {
            toastr.error('Please update estimated cost before starting campaign!')
        }
    };


    sendSMS = async (test) => {
        // console.log('enteredSendSMS')
        //await this.getCostEstimate()
        // let insufficientBalance = false;//this.state.balance < this.state.costEstimate;
        let zeroContacts = this.state.contactsCount === 0 || this.state.noContacts;
        let personalizationError = false;
        let personalizeOptions = this.state.personalizeOptions
        let improperPhonesError = this.state.improperPhones
        let emptyMessageError = this.state.emptyMessageError
        emptyMessageError = this.state.messageContent === '';
        let i = 0;
        if (this.state.messageContent.includes("{{")) {

            let result = this.getParameters(this.state.messageContent);
            ////console.log('parameters result :', result);

            for (i; i < result.length; i++) {
                if (result[i] !== 'first_name' && result[i] !== 'last_name' && result[i] !== 'full_name') {
                    personalizationError = true
                } else {
                    if (!personalizeOptions.includes(result[i])) {

                        personalizeOptions = [...personalizeOptions, result[i]];
                        ////console.log('personalize options after: ', personalizeOptions)
                    }
                    personalizationError = false

                }
            }
        }
        ////console.log('personalize error: ', personalizationError);

        //checking for errors
        await this.setState({
            //balanceError: insufficientBalance,
            contactsError: zeroContacts,
            personalizeOptions: personalizeOptions,
            personalizationError: personalizationError,
            emptyMessageError: emptyMessageError
        });

        if (this.state.update === false) {
            let noErrors = ''
            if (this.state.selectedRecipient === 'Add Manually') {
                noErrors = this.state.estimateError === false && this.state.emptyMessageError === false
                    //&& this.state.balanceError === false
                    && this.state.contactsError === false && this.state.personalizationError === false && this.state.contactsCount !== '' && this.state.improperPhones.length === 0

            } else {
                noErrors = this.state.estimateError === false && this.state.emptyMessageError === false
                    //&& this.state.balanceError === false
                    && this.state.contactsError === false && this.state.personalizationError === false && this.state.contactsCount !== ''

            }
            ////console.log('noErrors: ', noErrors);

            if (noErrors) {
                await this.setState({
                    loading: true, disabled: false
                })
                let userId = getCurrentUserId()
                let selectedSource = this.props.selectedSource;
                let data = '';
                let selectedTagIds = this.state.selectedTagIds


                if (this.state.selectedRecipient === 'Add Manually') {
                    ////console.log('entered add manually data')
                    data = {
                        "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                        "from": this.state.sender, //"provider": "twilio",//to calculate-obtain price for estimate based on provider prices
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 1,//use manually pasted contacts (phone numbers)
                        "phones": this.state.numbersArray,//send as an array of phones
                        "phones2": [],//send as string with comma separated values
                        "country_codes": [],//which country codes to include in sending-sends only to contacts who match this criteria
                        "personalize_parameters": [], "personalize": 0, "message_html": this.state.messageHTML

                    }
                } else if (this.state.selectedRecipient === 'All Contacts') {
                    data = {
                        "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                        "from": this.state.sender, //"provider": "twilio",//to calculate-obtain price for estimate based on provider prices
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "phones2": [],//send as string with comma separated values
                        "country_codes": [],//which country codes to include in sending-sends only to contacts who match this criteria,
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize,
                        "message_html": this.state.messageHTML

                    }
                } else {
                    data = {
                        "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                        "from": this.state.sender, //"provider": "twilio",//to calculate-obtain price for estimate based on provider prices
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": this.state.selectedTags.length > 0 ? 1 : 0,//use tags or not for sending
                        "tag_ids": selectedTagIds,//list of tag ids (existing tags client previously created)
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "phones2": [],//send as string with comma separated values
                        "country_codes": this.state.selectedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize,
                        "message_html": this.state.messageHTML

                    }
                }

                try {

                    // //console.log('send sms data: ', data)
                    // //console.log('send sms call: ', '/api/user/' + userId + '/project/' + selectedSource + '/sms_message')
                    this.handleMessageUpdate(this.state.messageContent)
                    let smsResponse = test === 'test' ? await http.post('/api/user/' + userId + '/project/' + selectedSource + '/sms_verified_only', {
                        "message": this.state.messageContent,
                        "from": this.state.alphanumericId !== '' ? this.state.alphanumericId : '',
                        "verified_contacts": this.state.verifiedNumbersIds
                    }, {
                        headers: {
                            'Content-Type': 'application/json', authorization: authService.getJwt()
                        }
                    }) : await http.post('/api/user/' + userId + '/project/' + selectedSource + '/sms_message', data, {
                        headers: {
                            'Content-Type': 'application/json', authorization: authService.getJwt()
                        }
                    })

                    // //console.log('smsResponse: ', smsResponse);

                    if (!smsResponse.data.error) {
                        console.log('no error')
                        console.log('No funds error')
                        if (smsResponse.data.message) {
                            // console.log('has message')
                            if (smsResponse.data.message === 'empty message') {
                                this.setState({
                                    loading: false, disabled: false, update: true, topUpBalance: true
                                })
                            } else {
                                this.setState({
                                    loading: false, disabled: false, update: true, emptyMessageError: true
                                })
                            }
                            //toastr.error('Sending unsuccessful.' + ' ' + smsResponse.data.message)
                            this.props.updateUserFromServer()

                        } else {
                            // console.log('no message')
                            let freeMessagesRemaining = smsResponse.data.error ? this.state.freeMessages : smsResponse.data.free_messages_remaining

                            // console.log('data.free_messages_remaining: ', smsResponse.data.free_messages_remaining)
                            // console.log('free messages remaining after sms: ', freeMessagesRemaining)


                            this.setState({
                                loading: false,
                                disabled: false,
                                freeMessages: freeMessagesRemaining,
                                update: true,
                                smsSentModalActive: true

                            })
                            this.props.updateUserFromServer()

                        }
                    } else {
                        // console.log('has error')
                        ////console.log('There is funds error')
                        //this.props.updateUserFromServer()

                        this.setState({
                            loading: false, disabled: false, update: true
                        })
                        // console.log('smsResponse.data.message: ', smsResponse.data.message)
                        toastr.error('Sending unsuccessful.' + ' ' + smsResponse.data.message)
                    }
                } catch (e) {
                    ////console.log('send message error: ', e)
                    this.setState({
                        loading: false, disabled: false, checkErrors: true
                    })

                }
            } else {
                this.setState({
                    loading: false, disabled: false, checkErrors: true
                })
            }
        } else {
            toastr.error('Please update estimated cost before starting campaign!')
        }
    }


    multiMenuItem = (item, {modifiers, handleClick}) => {
        if (this.state.selectedTags.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}
                />

            )
        } else {
            return (<MenuItem
                className='multiselect-menu-item'
                icon='small-tick'
                active={modifiers.active}
                key={item.id}
                label=''
                text={item.tag}
                onClick={handleClick}
                shouldDismissPopover={true}
            />)
        }
    };

    countryMenuItem = (item, {modifiers, handleClick}) => {
        if (this.state.selectedCountries.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.name}
                    label=''
                    text={item.name + ' ' + '(' + item.dial_code + ')' + ' ' + item.flag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}

                />)
        } else {
            return (<MenuItem
                className='multiselect-menu-item'
                icon='small-tick'
                active={modifiers.active}
                key={item.name}
                label=''
                text={item.name + ' ' + '(' + item.dial_code + ')' + ' ' + item.flag}
                onClick={handleClick}
                shouldDismissPopover={true}
            />)
        }
    };


    tagSelect = async (item) => {

        let selectedTagIds = [];
        ////console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;


        ////console.log('selected tags ids:', selectedTagIds);
        if (selectedTags.includes(item) === false) {

            selectedTags.push(item);
            await this.setState({selectedTags: selectedTags});
        } else {
            const newTags = await selectedTags.filter(t => t !== item);
            await this.setState({selectedTags: newTags})
        }

        this.state.selectedTags.map(tag => {
            selectedTagIds = [...selectedTagIds, tag.id]
        });
        this.getCostEstimate();

    };

    triggerUpsellModal = async () => {
        // //console.log('upsellModalOpen')
        this.setState({
            upgradeModalActive: true,
            upgradeModalTitle: 'Personalization is not available on your current plan.',
            upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`,
        })
    }
    utmTagsUnavailableUpsellModal = () => {

        this.setState({
            upgradeModalTitle: "UTM Tracking is not available on your current plan.", upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`, upgradeModalActive: true
        })

    }
    selectSender = async (sender) => {
        //console.log('sender:', sender)

        let senderParsed = sender['numberParsed'] ? sender['numberParsed'] : sender
        await this.setState({
            sender: senderParsed
        })
    }
    countrySelect = async (item) => {
        ////console.log('selected country: ', item);
        let selectedCountries = this.state.selectedCountries;

        let selectedDialCodes = this.state.selectedDialCodes;
        ////console.log('selected tags ids:', selectedTagIds);
        if (selectedCountries.includes(item) === false) {
            selectedDialCodes.push(item.dial_code);
            selectedCountries.push(item);
            await this.setState({selectedCountries, selectedDialCodes});
        } else {
            let newCountries = await selectedCountries.filter(t => t !== item);
            let newPhones = await selectedDialCodes.filter(p => p.dial_code !== item.dial_code);
            await this.setState({selectedCountries: newCountries, selectedDialCodes: newPhones})
        }
        this.getCostEstimate();
    };

    filterTags = (item) => {

        ////console.log('filter item:', item);

        return this.props.tags.filter((t) => {
            return t.tag.toLowerCase().includes(item.toLowerCase());
        });
    };

    filterCountries = (item) => {

        ////console.log(' country filter item:', item);

        return countries.filter((c) => {
            return c.name.toLowerCase().includes(item.toLowerCase());
        });
    };

    tagRender = (item) => {


        // //console.log('tag render item:', item);
        // //console.log('')
        return (<Tag key={item.id}>{item.tag}</Tag>)
        // //console.log('tag render end');
    };

    countryRender = (item) => {

        ////console.log('flags :', this.state.flags[code]);
        //sets country code to lowercase

        return (<Tag key={item.name}>

            <span style={{marginRight: 8}}>{item.flag}</span>
            {item.dial_code}
        </Tag>)

    }


    handleTagRemove = async (item) => {


        let selectedTagIds = [];
        ////console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;


        // //console.log('selected tags:', selectedTags);
        // //console.log('item', item);
        // //console.log('itemId:', item.key);

        const newTags = await selectedTags.filter(t => t.tag !== item.props.children);

        newTags.map(tag => {
            selectedTagIds = [...selectedTagIds, tag.id]
        });

        //console.log('newTags: ', newTags);
        //console.log('selectedTagIds -  remove: ', selectedTagIds);

        await this.setState({selectedTags: newTags});
        await this.getCostEstimate();

    };

    handleCountryRemove = async (item) => {

        ////console.log('country item: ', item);

        const selectedCountries = this.state.selectedCountries;
        const selectedDialCodes = this.state.selectedDialCodes;

        ////console.log('selectedCountries :', selectedCountries)
        const newCountries = await selectedCountries.filter(c => c.name !== item.key);
        const newPhones = await selectedDialCodes.filter(p => p.dial_code !== item.dial_code)
        ////console.log('newCountries :', newCountries)
        await this.setState({selectedCountries: newCountries, selectedDialCodes: newPhones})
        this.getCostEstimate();

    };

    senderRender = (item, {modifiers, handleClick}) => {

        return (

            <MenuItem
                key={item.text}
                text={item.text}
                value={item.text}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />)
    };

    operatorRender = (item, {modifiers, handleClick}) => {

        return (

            <MenuItem
                key={item.value}
                text={item.value}
                value={item.value}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />)
    };

    senderItemSelect = (item) => {
        this.setState({selectedSender: item.text})
    }
    operatorItemSelect = (item) => {
        this.setState({selectedOperator: item.text})
    }


    handlePhoneNumbers = (numbers) => {
        let numbersArray = numbers.replace(/ /g, '').split(',');
        // console.log('handlePhoneNumbersArray: ', numbersArray)

        this.setState({
            listOfNumbers: numbers, numbersArray: numbersArray, update: true
        });

    };

    getProjectPhones = async () => {
        // console.info('entered get project phones')
        // console.log('phonesSource: ', this.state.phonesSource)
        // console.log('selectedSource: ', this.state.selectedSource)
        // if (this.state.phonesSource !== this.state.selectedSource) {
        let selectedSource = await this.state.selectedSource ? this.state.selectedSource : JSON.parse(localStorage.source_clicked);
        //console.log('getProjectPhones - selectedSource: ', selectedSource)
        let user = await this.props.user;
        //console.log('getProjectPhones - user', user)
        if (user && user.id && selectedSource) {
            try {

                const result = await http.get('/api/user/' + user.id + '/project/' + selectedSource + '/project_phones', {headers: {authorization: getJwt()}});

                //console.log('project_phones result: ', result)
                await this.setState({
                    //phonesSource: this.state.selectedSource,
                    projectPhones: result.data.project_phones,
                })

            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    // toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        toastr.error(ex.response.data.message);
                        this.props.history.push('/logout');
                    }
            }
        }

        // } else {
        //     console.log('already got phones for this source')
        // }
    }
    handleRecipient = async (e) => {
        // console.log(e.target.textContent);
        let textContent = await e.target.textContent
        await this.setState({
            //balanceError: false,
            contactsError: false,
            selectedRecipient: textContent,
            error: '',
            attemptingMessages: '',
            remainingCredits: '',
            contactsCount: '',
            update: true
        })
        if (textContent === 'All Contacts' || textContent === 'Use Segments') {
            await this.getCostEstimate()
        }

    };
    handleWhen = async (e) => {
        await this.setState({selectedWhen: e.target.textContent})
    }
    toggleEmoji = async () => {
        let x = document.querySelector('.emoji-mart');

        if (x.style.display === "none") {
            document.querySelector('#post-message-text').focus();
            x.style.display = "block";
            await this.setState({native: true})
        } else {
            x.style.display = "none";
            await this.setState({native: true})
        }
    };
    getCursorPosition = () => {
        let textarea = document.getElementById("sms")
        //console.log('textarea: ', textarea)

        let cursorPosition = textarea.selectionStart

        //console.log('cursorPosition: ', cursorPosition)

        this.setState({
            cursorPosition
        })
    }

    changedSender = () => {
        //console.log('changed sender')
    }

    render() {

        let minimalEstimateCost
        let vatCountry = this.state.listOfEuAbbreviations.filter(country => country === this.state.country)
        ////console.log('vatCountry: ', vatCountry)
        if (vatCountry) {
            // //console.log('vatCountry length: ', vatCountry.length);
        }

        if (vatCountry.length > 0 && this.state.country !== '') {
            ////console.log('vat country length is not 0, it is: ', vatCountry.length)
            minimalEstimateCost = parseFloat(this.state.costEstimate * 1.2)
        } else {
            ////console.log('vat country length is 0')
            minimalEstimateCost = parseFloat(this.state.costEstimate)
        }
        ////console.log('minimalEstimateCost: ',minimalEstimateCost)

        return (<React.Fragment>
            <h1 className='main-title'>SMS</h1>
            <p className="nav-back" onClick={() => this.props.history.push('/new')}><i
                className="fas fa-chevron-left"></i> New Campaign</p>
            <div className="">
                <div className="fb-message-wrapper sms-wrapper campaign-container">

                    <div className="full-row-label text-bold m-m-b all-caps campaign-panel-title">
                        New SMS Campaign
                    </div>
                    {/*{this.state.freeMessages !== '' ?*/}
                    {/*    this.state.freeMessages === 10 ?*/}
                    {/*        <Callout*/}
                    {/*            intent='primary'*/}
                    {/*            icon='info-sign'*/}
                    {/*        >*/}
                    {/*            You can send {this.state.freeMessages} free text messages.*/}

                    {/*        </Callout>*/}
                    {/*        :*/}

                    {/*        this.state.freeMessages !== 0 ?*/}
                    {/*            <Callout*/}
                    {/*                intent='primary'*/}
                    {/*                icon='info-sign'*/}
                    {/*            >*/}
                    {/*                <React.Fragment>*/}
                    {/*                    You have {this.state.freeMessages} free text messages remaining.*/}
                    {/*                    <a target='_blank'*/}
                    {/*                       href="https://emitto.io/free-credits-country-availability/">See Free*/}
                    {/*                        Credits Country Availability</a>*/}
                    {/*                </React.Fragment>*/}
                    {/*            </Callout>*/}
                    {/*            :*/}

                    {/*            ''*/}
                    {/*    :*/}
                    {/*    ''*/}
                    {/*}*/}

                    <div className="flex-row-wrapper">
                        <div className="half-width">
                            <p className='trigger-options-title m-k-b'>Message Details</p>

                            <div className="sms-select-container m-m-b">
                                <div className="display-flex justify-content-space">
                                    <label style={{marginBottom: 0}} className='send-from-text'>Send From <Tooltip
                                        className={Classes.TOOLTIP_INDICATOR}
                                        content={<div style={{backgroundColor: '#344A5E', padding: 20}}>
                                            We will
                                            automatically
                                            choose
                                            the best sender option from what you have set, based on your campaign
                                            preferences.
                                            For Sender Pool configuration to SMS Settings under the Channels tab.
                                        </div>}


                                        usePortal={false}
                                    >
                                            <span className='ml-[8px] !text-[#344A5E]'>
                                                <i className="fas fa-info-circle !text-[#344A5E]"></i>
                                            </span>
                                    </Tooltip></label>
                                    {/*<label>Send From <Tooltip*/}
                                    {/*    // interactionKind={PopoverInteractionKind.CLICK}*/}

                                    {/*    className={Classes.TOOLTIP_INDICATOR}*/}
                                    {/*    content={<Callout icon='info-sign' intent={Intent.PRIMARY}>*/}
                                    {/*    </Callout>}*/}

                                    {/*    usePortal={false}*/}
                                    {/*>*/}
                                    {/*    <span className="far fa-question-circle"></span>*/}
                                    {/*</Tooltip></label>*/}
                                    <Popover
                                        position={Position.BOTTOM}
                                        interactionKind={PopoverInteractionKind.CLICK}
                                        className='profile-popover'

                                    >
                                        <span className='edit-blue-link'>Edit</span>
                                        <div className='padding-10 edit-alphanumeric-popover'>
                                            <p className='text-semi-bold margin-bottom-10'>Alphanumeric ID</p>
                                            <div className="margin-bottom-5">
                                                <label className='radio-container'
                                                    // onClick={() => this.selectSender(this.state.alphanumericId)}
                                                       htmlFor="alphanumeric-id">
                                                    <p className='d-inline-b margin-right-10'>{this.state.alphanumericId}</p>
                                                    <input checked={this.state.sender === this.state.alphanumericId}
                                                           onChange={this.changedSender}
                                                           onClick={() => this.selectSender(this.state.alphanumericId)}
                                                           type="radio" id='alphanumeric-id' name='senderSelect'/>
                                                    <span className='checkmark'></span>

                                                </label>
                                            </div>

                                            <hr/>
                                            <p className='text-bold margin-bottom-10'>Phone Numbers</p>
                                            {this.state.projectPhones.map(number => {

                                                //console.log('number: ', number)
                                                const numberParsed = number.phone_number
                                                return (<div key={numberParsed} className='margin-bottom-5'>
                                                        <label className='radio-container'
                                                            //onClick={() => this.selectSender(numberParsed)}
                                                               htmlFor={numberParsed}>
                                                            <p className='d-inline-b'>{numberParsed}</p>
                                                            <input checked={this.state.sender === numberParsed}
                                                                   onChange={this.changedSender}
                                                                   onClick={() => this.selectSender(numberParsed)}
                                                                   type="radio" id={numberParsed}
                                                                   name='senderSelect'/>
                                                            <span className='checkmark'></span>

                                                        </label>
                                                    </div>

                                                )
                                            })}
                                        </div>
                                    </Popover>
                                </div>
                                <Tooltip
                                    popoverClassName="bp3-popover-content-sender-pool"
                                    className={Classes.TOOLTIP_INDICATOR}
                                    interactionKind={PopoverInteractionKind.CLICK}
                                    content={<div className='sender-pool-container'>
                                        <h2>SENDER POOL</h2>
                                        <p className='label'>Alphanumeric ID</p>
                                        {this.state.alphanumericId ?
                                            <p className='content'>{this.state.alphanumericId}</p> :
                                            <p className='empty-content'>No Alphanumeric Id</p>}
                                        <div style={{position: 'relative'}}>
                                            <p className='label'>Phone Numbers</p>
                                            <span className='edit-blue-link'
                                                  onClick={() => this.props.history.push('/phone-numbers')}>Buy a
                                                    phone number</span>

                                            {this.state.projectPhones && this.state.projectPhones.length ? this.state.projectPhones.map(number => {
                                                let country = countries.find(country => country.code === number.country_iso)
                                                return <p
                                                    key={number.phone_number}
                                                    className='content'>{country ? country.flag : ''} {number.phone_number}</p>
                                            }) : <p className='empty-content'>
                                                {this.state.projectPhones.length ? this.state.projectPhones.map(number => {
                                                    return (<div
                                                        key={number.phone_number}>{number.phone_number}</div>)
                                                }) : 'This Workspace does not have any phone numbers'}

                                            </p>}
                                        </div>

                                    </div>}>
                                    <Select
                                        items={this.state.senders}
                                        itemRenderer={this.senderRender}
                                        onItemSelect={this.senderItemSelect}
                                        filterable={false}
                                        className='sendersSelector'
                                        disabled={true}
                                        style={{width: '100%'}}
                                    >
                                        <Button text={this.state.sender} rightIcon="eye-open"/>
                                    </Select>
                                </Tooltip>


                            </div>

                            {this.state.brandError === true ? <div className="input-notification-danger">
                                Brand name can only contain letters or numbers up to 11 characters.
                            </div> : ''}

                            {/*<ContentEditableTextarea*/}
                            {/*    uniqueId='sms-message'*/}
                            {/*    utmTagsUnavailableUpsellModal={this.utmTagsUnavailableUpsellModal}*/}
                            {/*    onUpdate={this.handleMessageUpdate}*/}
                            {/*    label={'Message'}*/}
                            {/*    placeholder={'Your SMS message goes here'}*/}
                            {/*    height={120}*/}
                            {/*    //maxCharacters={1000}*/}
                            {/*    infoCircleType={'question'}*/}
                            {/*    infoCircleContent='Message'*/}
                            {/*    showMessagesNumber={true}*/}
                            {/*    personalize={this.state.selectedRecipient !== 'Add Manually'}*/}
                            {/*    triggerUpsellModal={this.triggerUpsellModal}*/}
                            {/*    plan={this.state.sourcePlan}*/}
                            {/*    selectedSource={this.state.selectedSource}*/}
                            {/*    viber={false}*/}
                            {/*    messageContent={this.state.messageContent}*/}
                            {/*    rerunCampaignData={this.state.rerunCampaignData}*/}
                            {/*    html={this.state.messageHTML}*/}
                            {/*    selectedSourceFull={this.state.selectedSourceFull[0]}*/}
                            {/*/>*/}

                            <CampaignsTextArea
                                triggerUpsellModal={this.triggerUpsellModal}
                                selectedRecipient={this.state.selectedRecipient}
                                updateCursorPosition={this.updateCursorPosition}
                                viber={false}
                                uniqueId='sms'
                                onUpdate={this.handleSmsFallbackMessage}
                                label={'Message'}
                                placeholder={'Your SMS message goes here'}
                                height={120}
                                // maxCharacters={125}
                                infoCircleType={'question'}
                                infoCircleContent='Message'
                                showMessagesNumber={true}
                                personalize={true}
                                plan={this.state.sourcePlan}
                                selectedSourceFull={this.state.selectedSourceFull[0] ? this.state.selectedSourceFull[0] : ''}
                                selectedSource={this.state.selectedSource}
                                messageContent={this.state.messageContent}
                                cursorPosition={this.state.cursorPosition}
                                onClick={this.getCursorPosition}
                                sendButton={true}
                                buttonLoading={this.state.loading}
                            />

                            <p className='m-lg-t trigger-options-title m-k-b'>Recipients</p>

                            <div className='flex-direction-row recipients m-m-b'>
                                <div onClick={this.handleRecipient}
                                     className={this.state.selectedRecipient === 'Add Manually' ? "recipient active" : 'recipient'}
                                >
                                    Add Manually
                                </div>
                                <div onClick={this.handleRecipient}
                                     className={this.state.selectedRecipient === 'All Contacts' ? "recipient active" : 'recipient'}>
                                    All Contacts
                                </div>
                                <div onClick={this.handleRecipient}
                                     className={this.state.selectedRecipient === 'Use Segments' ? "recipient active" : 'recipient'}
                                >
                                    Use Segments
                                </div>
                            </div>
                            <div className="recipient-section">
                                {this.state.selectedRecipient === 'Add Manually' ?
                                    <div className="form-group primary-text ">
                                        <p>Paste Numbers</p>
                                        <textarea id='message-numbers'
                                                  className={this.state.listOfNumbers !== '' ? 'post-message-text valid' : 'post-message-text'}
                                                  placeholder="Type or paste phone numbers here. Separated by comma (,). You can add up to 500 numbers. Example:. +108001234567"

                                                  onChange={(e) => {
                                                      this.handlePhoneNumbers(e.target.value)
                                                  }}
                                                  value={this.state.listOfNumbers}>

                            </textarea>
                                        {/*<div className="sms-buttons m-s-t">*/}
                                        {/*    <button className=' btn-action'*/}
                                        {/*            disabled={this.state.loading ? true : ''}*/}
                                        {/*            onClick={this.getCostEstimate}>*/}
                                        {/*        Estimate cost*/}
                                        {/*        {*/}
                                        {/*            this.state.loading ?*/}
                                        {/*                <i className='fa fa-spin fa-spinner'></i>*/}
                                        {/*                :*/}
                                        {/*                ""*/}
                                        {/*        }*/}
                                        {/*    </button>*/}
                                        {/*</div>*/}
                                    </div> : this.state.selectedRecipient === 'All Contacts' ? !this.state.smsWontBeSent ? !this.state.update ?
                                        <Callout className='m-s-t'>
                                            {this.state.loading === true ? <React.Fragment>
                                                    <Spinner size={21}/>
                                                </React.Fragment> :

                                                this.state.noContacts === false ?

                                                    <React.Fragment>
                                                        SMS will be sent
                                                        to {this.state.contactsCount} contacts
                                                        in your data base.
                                                    </React.Fragment>

                                                    : <React.Fragment>
                                                        You have <span
                                                        className='text-bold'>0 </span> contacts
                                                        in your data base. <Link to="/import-contacts">Import
                                                        contacts</Link>
                                                    </React.Fragment>}
                                        </Callout> : '' : '' : <React.Fragment>
                                        {this.state.selectedSourceFull && this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].use_custom_plan && this.state.selectedSourceFull[0].custom_plan && this.state.selectedSourceFull[0].custom_plan.additional_features ? this.state.selectedSourceFull[0].custom_plan.additional_features.tags_segmentation === 0 ?
                                                <Callout
                                                    intent='primary'
                                                    icon='info-sign'
                                                >
                                                    <React.Fragment>
                                                        Segments are not available
                                                        on {this.state.selectedSourceFull[0].custom_plan.name} plan. <br></br>
                                                        To unlock segmentation<a
                                                        onClick={this.openUpgradeModal}
                                                        href="#">upgrade now.</a>
                                                    </React.Fragment>
                                                </Callout> : ''

                                            : this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].plan && this.state.selectedSourceFull[0].plan.additional_features && this.state.selectedSourceFull[0].plan.additional_features.tags_segmentation === 0 ?
                                                <Callout
                                                    intent='primary'
                                                    icon='info-sign'
                                                >
                                                    <React.Fragment>
                                                        Segments are not available
                                                        on {this.state.selectedSourceFull[0].plan.name} plan. <br></br>
                                                        To unlock segmentation<a
                                                        onClick={this.openUpgradeModal}
                                                        href="#">upgrade now.</a>
                                                    </React.Fragment>
                                                </Callout> : ''}
                                        <p className='m-m-t'>Send to contacts with these tags</p>
                                        <MultiSelect
                                            items={this.props.tags}
                                            itemRenderer={this.multiMenuItem}
                                            tagInputProps={{
                                                placeholder: 'Filter by tag', onRemove: this.handleTagRemove
                                            }}
                                            resetOnSelect={true}
                                            className='tag-multiselect countries-multiselect'
                                            onItemSelect={this.tagSelect}
                                            tagRenderer={this.tagRender}
                                            itemListPredicate={this.filterTags}
                                            selectedItems={this.state.selectedTags}
                                            fill={true}
                                            noResults={<MenuItem disabled={true} text="No results."/>}

                                        />
                                        <p>Send to specific country</p>
                                        <MultiSelect
                                            items={countries}
                                            itemRenderer={this.countryMenuItem}
                                            tagInputProps={{
                                                placeholder: 'Filter by country', onRemove: this.handleCountryRemove
                                            }}
                                            filterable={true}
                                            resetOnSelect={true}
                                            className='tag-multiselect'
                                            onItemSelect={this.countrySelect}
                                            tagRenderer={this.countryRender}
                                            itemListPredicate={this.filterCountries}
                                            selectedItems={this.state.selectedCountries}
                                            fill={true}
                                            noResults={<MenuItem disabled={true} text="No results."/>}
                                        />
                                        {this.state.noContacts === true ?


                                            <Callout
                                                className='m-m-t'
                                            >

                                                <React.Fragment>
                                                    You have <span className='text-bold'>0 </span> contacts
                                                    in
                                                    your data base. <Link
                                                    to="/import-contacts">Import contacts</Link>
                                                </React.Fragment>

                                            </Callout> : this.state.showContactsCount ? this.state.contactsCount !== 0 ?
                                                <Callout
                                                    intent='success'
                                                    className='m-m-t'
                                                >
                                                    {this.state.loading === true ? <React.Fragment>
                                                        <Spinner size={21}/>
                                                    </React.Fragment> : <React.Fragment>
                                                                        <span
                                                                            className='text-bold'>{this.state.contactsCount !== undefined ? this.state.contactsCount : this.state.attemptingMessages}</span> {this.state.contactsCount === 1 ? 'contact ' : 'contacts '}
                                                        in your data base match this criteria.
                                                    </React.Fragment>}
                                                </Callout> : <Callout
                                                    className='m-m-t'
                                                >

                                                    {this.state.loading === true ? <React.Fragment>
                                                        <Spinner size={21}/> </React.Fragment> : <React.Fragment>
                                                        There are no contacts in your data base
                                                        matching
                                                        this criteria.
                                                    </React.Fragment>}
                                                </Callout> : ''}
                                    </React.Fragment>


                                }
                                {this.state.costEstimate === 'Not enough remaining credits' && this.state.update === false ?

                                    '' : //     this.state.workspaceBalance ?
                                    this.state.loading ?

                                        <span className='viber-spinner-container'>
                                                    <Spinner size={75}/>
                                                </span>

                                        :

                                        this.state.update ? <Callout
                                                className={this.state.highlightCostEstimate ? 'estimate-cost-callout red-border' : 'estimate-cost-callout'}>


                                                        <span className='flex-row justify-content-space'>

                                                            <div className='flex-row estimated-cost-container'>
                                                                Estimated Cost:
                                                            </div>

                                                            <span
                                                                onClick={this.updateCostEstimate}
                                                                className={'cost-estimate-value cost-free update'}
                                                            >UPDATE
                                                            </span>
                                                        </span>
                                            </Callout>

                                            :

                                            //UPDATED
                                            Number(this.state.costEstimate) === 0 ? //FREE CASE
                                                <Callout className='estimate-cost-callout'>


                                                            <span className='flex-row justify-content-space'>
                                                                <div>
                                                                    <div className='flex-row estimated-cost-container'>
                                                                        Estimated Cost:
                                                                    </div>
                                                                    {/*<span*/}
                                                                    {/*    className='grey-text'>{this.state.freeMessagesInitial - this.state.freeMessagesRemaining + ' '}*/}
                                                                    {/*    free SMS will be used</span>*/}
                                                                </div>
                                                                <span
                                                                    className='cost-estimate-value cost-free'>FREE</span>
                                                            </span>

                                                </Callout>

                                                :

                                                // NOT FREE CASE
                                                <React.Fragment>
                                                    <Callout className='estimate-cost-callout viber-total-cost'>

                                                                <span className='flex-row justify-content-space'>

                                                                    <div className='flex-row estimated-cost-container'>
                                                                        Total Cost
                                                                    </div>
                                                                    {/*{this.state.freeMessagesInitial !== 0 ?*/}
                                                                    {/*    // <span*/}
                                                                    {/*    //     className='grey-text free-messages-cost-estimate'>{this.state.freeMessagesInitial - this.state.freeMessagesRemaining + ' '}*/}
                                                                    {/*    //     free SMS will be used</span>*/}
                                                                    {/*    :*/}
                                                                    {/*    ''*/}
                                                                    {/*}*/}
                                                                    <span
                                                                        className='cost-estimate-value viber-cost-estimate-value text-bold'>

                                                                        {

                                                                            this.state.costEstimate + ' credits'}
                                                                        {/*}*/}
                                                                    </span>

                                                                </span>
                                                        <hr/>
                                                        <span className='flex-row justify-content-space'>
                                                                    <div>Available Workspace Credits</div>
                                                                    <div>
                                                                        {Number(this.state.workspaceCredits).toFixed(2)} credits

                                                                    </div>
                                                                </span>
                                                        <span className='flex-row justify-content-space'>
                                                                    <div>
                                                                        Top-up Required
                                                                    </div>
                                                                    <span className="display-flex flex-column">
                                                                    <div className='blue-text'>
                                                                        {this.state.topUpAmount !== '' ? Number(this.state.topUpAmount).toFixed(2) + ' credits'

                                                                            : '0.00'}

                                                                    </div>
                                                                        <div
                                                                            className='display-flex blue-text full-width justify-content-end'>
                                                                        {this.state.topUpDollars !== '' ? '($ ' + Number(this.state.topUpDollars).toFixed(2) + ')'

                                                                            : '($0.00)'}

                                                                    </div>
                                                                    </span>

                                                                </span>
                                                        {/*<span className='flex-row justify-content-space'>*/}
                                                        {/*    <div>*/}
                                                        {/*        Top-up Amount*/}
                                                        {/*    </div>*/}
                                                        {/*    <div className='blue-text'>*/}
                                                        {/*        $ {this.state.topUpAmount !== '' ?*/}
                                                        {/*        this.state.vatPercent !== 0 && this.state.vatPercent !== '' ?*/}
                                                        {/*            (Number(this.state.topUpAmount) + Number((this.state.topUpAmount / 100) * this.state.vatPercent)).toFixed(2) :*/}
                                                        {/*            Number(this.state.topUpAmount).toFixed(2)*/}

                                                        {/*        : '0.00'}*/}
                                                        {/*        {this.state.vatPercent !== 0 && this.state.vatPercent !== '' && this.state.topUpAmount !== '' && this.state.topUpAmount !== 0 ?*/}
                                                        {/*            <span className='vat-included'>*/}
                                                        {/*                (VAT*/}
                                                        {/*                included:${Number((this.state.topUpAmount / 100) * this.state.vatPercent).toFixed(2)})*/}
                                                        {/*            </span>*/}
                                                        {/*            : ''}*/}
                                                        {/*    </div>*/}
                                                        {/*</span>*/}
                                                    </Callout>

                                                    {this.state.topUpDisclaimer ?
                                                        <p className='text-right minimal-charge top-up-disclaimer'>
                                                            Minimal top-up amount is 1000 credits
                                                        </p> : ''}

                                                    <div id='sms'
                                                         className='new-balance-viber display-flex justify-content-space'>
                                                                <span>
                                                                    <span className='text-bold'>
                                                                        {Number(this.state.remainingCredits).toFixed(2)}</span> credits
                                                                    remaining after this campaign
                                                                </span>

                                                    </div>
                                                </React.Fragment>

                                }

                                {this.state.personalizationNotice ? this.state.selectedRecipient !== 'Add Manually' ?
                                    <Callout
                                        className='margin-top-20'
                                        intent='primary'
                                        icon='info-sign'
                                    >
                                        When using <span className='text-semi-bold'>personalization</span> the
                                        actual
                                        cost may vary
                                        depending on the content of personalization tags.
                                    </Callout> : <Callout
                                        intent={"warning"}
                                        icon={'warning-sign'}
                                        className={'orange-callout margin-top-20'}
                                    >
                                        Personalization can't be used when <span className='text-semi-bold'>manual
                                                contacts</span> are selected as
                                        campaign recipients. We suggest you remove all personalization
                                        parameters before sending this campaign or they will be treated as plain
                                        text."
                                    </Callout> : ''

                                }
                                {(this.state.contactsCount === 0 || (this.state.firstMount !== true && this.state.contactsCount === ''))

                                    ? <Callout
                                        className='m-m-t'
                                        intent='primary'
                                        icon='info-sign'
                                    >
                                        Need more contacts for your
                                        campaigns? <Link to="/contacts">Upload
                                        here!</Link>
                                    </Callout> : ''}
                                {this.state.topUpBalance ? <Callout intent='danger' className='margin-top-20'>
                                    You need to <Link to="/billing/balance">add credits to your workspace
                                    balance</Link> -
                                    No workspace balance set up
                                </Callout> : ''}
                            </div>

                            <p className='m-lg-t trigger-options-title m-k-b'>When to send</p>
                            <div className='flex-direction-row when-to-send'
                            >
                                <Tooltip content="Coming Soon!" position={Position.BOTTOM}>
                                    <div
                                        className={this.state.selectedWhen === 'Schedule' ? "when-selection active" : 'when-selection disabled'}>

                                        Schedule

                                    </div>
                                </Tooltip>
                                <div
                                    className={this.state.selectedWhen === 'Immediately' ? "when-selection active" : 'when-selection'}>
                                    Immediately
                                </div>
                            </div>

                            <div className="sms-errors m-s-t ">
                                {this.state.checkErrors ? < Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    Please check the errors before clicking update.

                                </Callout> : ''}
                                {this.state.contactsError && !this.state.firstMount ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    {this.state.selectedRecipient === 'Add Manually' ?

                                        'Please add numbers to recipients area.' : <React.Fragment>
                                            You have <span className='text-bold'>0</span> contacts that match
                                            the
                                            selected criteria. There’s no-one to send the campaign to.
                                            <span className='close-error'></span>
                                        </React.Fragment>}


                                </Callout> : ''}
                                {this.state.estimateError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    <div className='messages-callout-info'>
                                        <p className='text-bold'>Not enough remaining credits</p>
                                        Attempting to
                                        send: <span>{this.state.attemptingMessages}</span>
                                        <br/>
                                        Credits remaining after this
                                        campaign <span>{this.state.remainingCredits}</span>
                                        <a className='d-block' href="/sms">Upgrade to Pro Plan</a>
                                    </div>
                                </Callout> : ''}
                                {this.state.emptyMessageError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    <div className='messages-callout-info'>
                                        <p>Your message can't be empty!</p>
                                    </div>
                                </Callout> : ''}

                                {/*{this.state.balanceError && this.state.contactsCount > 0 ?*/}
                                {/*    <Callout*/}
                                {/*        intent={"danger"}*/}
                                {/*        icon={'warning-sign'}*/}
                                {/*    >*/}
                                {/*        Insufficient balance on your account. Please top up your account to be able*/}
                                {/*        to*/}
                                {/*        send this campaign.*/}
                                {/*        <span className='close-error'></span>*/}
                                {/*    </Callout>*/}
                                {/*    :*/}
                                {/*    ''*/}
                                {/*}*/}

                                {this.state.improperPhones.length > 0 && this.state.improperPhones[0] !== null ?
                                    <Callout
                                        intent={"danger"}
                                        icon={'warning-sign'}
                                    >
                                        Improper phone numbers:
                                        {this.state.improperPhones.map(improperNumber => <div>
                                            {improperNumber}
                                        </div>)}

                                        <span className='close-error'></span>
                                    </Callout> : ''}
                                {this.state.personalizationError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    It seems like you're using an invalid personalisation markups. Please
                                    check
                                    your personalisation parameters for possible typo and use only values
                                    from
                                    "Personalize" menu.
                                    <span className='close-error'></span>
                                </Callout> : ''}
                            </div>
                            <div className="sms-buttons m-t-t">

                                <div className="flex-direction-row space-between">
                                    <Link to='/new'>
                                        <button
                                            className="btn-lite dist-platf-button"
                                            disabled={false}
                                            // onClick={(e) => {
                                            //     this.props.openModal(e)
                                            // }}

                                        >
                                            Cancel
                                        </button>
                                    </Link>
                                    <div className='flex'>
                                        {process.env.REACT_APP_ENVIRONMENT === 'DEV' ? <div
                                            className='margin-right-10'
                                        >
                                            {this.props.selectedSourceNode && (!this.props.selectedSourceNode.business_verification || (this.props.selectedSourceNode.business_verification && this.props.selectedSourceNode.business_verification.status && (this.props.selectedSourceNode.business_verification.status !== 'verified')) ?
                                                <Popover
                                                    interactionKind={PopoverInteractionKind.HOVER}
                                                    position={Position.TOP}

                                                >
                                                    <button
                                                        className="btn-action dist-platf-button"
                                                        disabled={true}>
                                                        Test Log
                                                    </button>
                                                    <p
                                                        className='padding-10'
                                                    >Until your business gets verified
                                                        you'll only be able to
                                                        Send Test Messages.</p>


                                                </Popover> : <button
                                                    className="btn-action dist-platf-button"
                                                    disabled={this.state.loading ? true : ''}
                                                    onClick={this.state.selectedSourceFull && this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].use_custom_plan && this.state.selectedSourceFull[0].custom_plan && this.state.selectedSourceFull[0].custom_plan.additional_features ? this.state.selectedSourceFull[0].custom_plan.additional_features.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments' ? this.openUpgradeModal : this.startLogCampaign : this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].plan && this.state.selectedSourceFull[0].plan.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments' ? this.openUpgradeModal : this.startLogCampaign

                                                    }
                                                >
                                                    Test Log
                                                    {this.state.loading ?
                                                        <i className='fa fa-spin fa-spinner'></i> : ""}
                                                </button>)}

                                        </div> : ''}

                                        <div
                                        >
                                            {this.props.selectedSourceNode && (!this.props.selectedSourceNode.business_verification || (this.props.selectedSourceNode.business_verification && this.props.selectedSourceNode.business_verification.status && (this.props.selectedSourceNode.business_verification.status !== 'verified')) ?
                                                <Popover
                                                    interactionKind={PopoverInteractionKind.HOVER}
                                                    position={Position.TOP}

                                                >
                                                    <button
                                                        className="btn-action dist-platf-button"
                                                        disabled={true}>
                                                        Start Campaign
                                                    </button>
                                                    <p
                                                        className='padding-10'
                                                    >Until your business gets verified
                                                        you'll only be able to
                                                        Send Test Messages.</p>


                                                </Popover> : <button
                                                    className="btn-action dist-platf-button"
                                                    disabled={this.state.loading ? true : ''}
                                                    onClick={this.state.selectedSourceFull && this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].use_custom_plan && this.state.selectedSourceFull[0].custom_plan && this.state.selectedSourceFull[0].custom_plan.additional_features ? this.state.selectedSourceFull[0].custom_plan.additional_features.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments' ? this.openUpgradeModal : this.startCampaign : this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].plan && this.state.selectedSourceFull[0].plan.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments' ? this.openUpgradeModal : this.startCampaign}
                                                >
                                                    Start Campaign
                                                    {this.state.loading ?
                                                        <i className='fa fa-spin fa-spinner'></i> : ""}
                                                </button>)}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="half-width">
                            <p className='trigger-options-title m-k-b'>Preview</p>
                            <div className="message-preview">
                                <div className="phone-markup">
                                    <div className="screen-markup">
                                        <div className="sender-markup">
                                            {this.state.alphanumericId !== '' ? this.state.alphanumericId : ''}
                                        </div>
                                        {this.state.messageContent !== '' ?
                                            <div className="message-markup sms-message-markup">
                                                    <span>
                                                         {this.state.messageContent}
                                                    </span>
                                            </div> : ''}
                                    </div>
                                </div>
                            </div>
                            <div className='flex-direction-row justify-content-center  m-m-t'>
                                <button
                                    className="btn-lite dist-platf-button"
                                    disabled={false}
                                    onClick={() => {
                                        this.state.messageContent ? this.setState({
                                            sendTestMessageModalActive: true
                                        }) : toastr.error("For testing purposes your message can't be empty!")
                                    }}>
                                    Send Test Message
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SendTestMessageModal
                showModal={this.state.sendTestMessageModalActive}
                handleClose={() => this.setState({sendTestMessageModalActive: false})}
                maxWidth={500}
                history={this.props.history}
                verifiedNumbers={this.state.verifiedNumbers}
                sendTestSMS={this.sendTestSMS}
            />
            <SMSSentModal
                showModal={this.state.smsSentModalActive}
                handleClose={() => this.setState({smsSentModalActive: false})}
                width={500}
                maxWidth={500}
                history={this.props.history}
                costEstimate={this.state.costEstimate}
                contacts={this.state.contactsCount}
                topUpAmount={this.state.topUpAmount}
                remainingCredits={this.state.remainingCredits}
                workspaceBalance={this.state.workspaceBalance}
                workspaceCredits={this.state.workspaceCredits}
                vatPercent={this.state.vatPercent}
            />
            <PaymentMethodMissingModal
                sms={true}
                showModal={this.state.paymentMethodModal}
                handleClose={() => this.setState({paymentMethodModal: false})}
                maxWidth={500}
                history={this.props.history}
                activateAddPaymentMethod={() => this.setState({
                    addPaymentMethodModalActive: true, paymentMethodModal: false
                })}
            />
            <AddPaymentMethodModal
                showModal={this.state.addPaymentMethodModalActive}
                handleClose={() => this.setState({addPaymentMethodModalActive: false})}
                maxWidth={600}
                history={this.props.history}
                user={this.props.user}
                updatePaymentMethods={this.getUserBilling}
                updateUserFromServer={this.props.updateUserFromServer}
                project={this.state.project || ''}
                selectedSource={this.props.selectedSource}
            />
            <PaymentMethodExpiredModal
                showModal={this.state.paymentMethodExpiredModal}
                handleClose={() => this.setState({paymentMethodExpiredModal: false})}
                maxWidth={500}
                history={this.props.history}
            />
            <UpsellModalTailwind
                selectedSource={this.state.selectedSource}
                showModal={this.state.upgradeModalActive}
                handleClose={() => this.setState({upgradeModalActive: false})}
                maxWidth={null}
                history={this.props.history}
                title={this.state.upgradeModalTitle}
                content={this.state.upgradeModalContent}
                buttonLink={this.state.modalButtonLink}
                buttonLabel={this.state.modalButtonLabel}
                plan={this.state.sourcePlan}
                user={this.props.user}
            />

        </React.Fragment>)
    }
}

export default Sms;